import React, { useRef, useState, useEffect } from 'react';

const FadeInView = ({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  once = true,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const directions = {
    up: { y: 40, x: 0 },
    down: { y: -40, x: 0 },
    left: { y: 0, x: -40 },
    right: { y: 0, x: 40 },
    none: { y: 0, x: 0 },
  };

  useEffect(() => {
    const element = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (once && element) {
            observer.unobserve(element);
          }
        } else if (!once) {
          setIsVisible(false);
        }
      },
      {
        // threshold 0: any visible pixel counts — tall blocks (e.g. long
        // blog posts on mobile) can never reach 10% of their own height
        threshold: 0,
        rootMargin: '0px',
      }
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [once]);

  const initial = directions[direction];

  return (
    <div
      ref={ref}
      className={`fade-in-view ${isVisible ? 'fade-in-visible' : ''} ${className}`}
      style={{
        '--fade-delay': `${delay}s`,
        '--initial-x': `${initial.x}px`,
        '--initial-y': `${initial.y}px`,
      }}
    >
      {children}
    </div>
  );
};

export default FadeInView;
